import React from 'react';
import { Users, MapPin, Lock, Server } from 'lucide-react';
export function TrustStrip() {
  const items = [{
    icon: Users,
    label: 'In-house team'
  }, {
    icon: MapPin,
    label: 'Boston-based'
  }, {
    icon: Lock,
    label: 'Client ownership'
  }, {
    icon: Server,
    label: 'Local hosting'
  }];
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-6 py-8" data-id="element-163">
      {items.map(item => <div key={item.label} className="flex items-center gap-3" data-id="element-164">
          <item.icon className="w-5 h-5 text-brand-teal flex-shrink-0" data-id="element-165" />
          <span className="text-sm font-semibold text-ink" data-id="element-166">{item.label}</span>
        </div>)}
    </div>;
}